module.exports = __webpack_public_path__ + "img/v_p1.7c75c01f.svg";